<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">
    <el-tabs type="border-card">
      <el-tab-pane label="样式配置">
        <a-spin :spinning="confirmLoading">
          <a-form :form="form">
            <!--<a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="导航栏样式">
              <el-select v-model="form.mode" placeholder="请选择">
                <el-option label='横向菜单栏' value='horizontal' key="1"></el-option>
                <el-option label='纵向菜单栏' value='vertical' key="2"></el-option>
              </el-select>
            </a-form-item>-->
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="字体类型">
              <el-select v-model="form.fontFamily" placeholder="请选择" style="width: 110px">
                <el-option label='楷体' value='楷体' key="1"></el-option>
                <el-option label='微软雅体' value='微软雅体' key="2"></el-option>
                <el-option label='黑体' value='黑体' key="3"></el-option>
              </el-select>
            </a-form-item>
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="字体大小">
              <el-select v-model="form.fontSize" placeholder="请选择" style="width: 110px">
                <el-option label='8' value='8px' key="1"></el-option>
                <el-option label='9' value='9px' key="2"></el-option>
                <el-option label='10' value='10px' key="3"></el-option>
                <el-option label='11' value='11px' key="4"></el-option>
                <el-option label='12' value='12px' key="5"></el-option>
                <el-option label='14' value='14px' key="6"></el-option>
                <el-option label='16' value='16px' key="7"></el-option>
                <el-option label='18' value='18px' key="8"></el-option>
                <el-option label='20' value='20px' key="9"></el-option>
                <el-option label='24' value='24px' key="10"></el-option>
                <el-option label='26' value='26px' key="11"></el-option>
                <el-option label='28' value='28px' key="12"></el-option>
                <el-option label='36' value='36px' key="13"></el-option>
                <el-option label='48' value='48px' key="14"></el-option>
              </el-select>
            </a-form-item>
          </a-form>
        </a-spin>
      </el-tab-pane>
      <el-tab-pane label="色彩配置">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="导航背景色">
          <el-color-picker v-model="form.backgroundColor"
                           :predefine="predefine"></el-color-picker>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="导航选中背景色">
          <el-color-picker v-model="form.activeColor" :predefine="predefine"></el-color-picker>
        </a-form-item>
        <!--<a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="悬浮背景色">
          <el-color-picker v-model="form.hoverColor" :predefine="predefine"></el-color-picker>
        </a-form-item>-->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="字体颜色">
          <el-color-picker v-model="form.fontColor" :predefine="predefine"></el-color-picker>
        </a-form-item>
      </el-tab-pane>
    </el-tabs>
  </a-modal>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    name: "eleMenuSimple",
    components: {
      draggable
    },
    data() {
      return {
        conKey: '',
        componentFlag: '',
        title: '导航栏配置',
        visible: false,
        confirmLoading: false,
        labelCol: {
          xs: {span: 24},
          sm: {span: 8},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 12},
        },
        form: {
          fontColor: '#000000',
          hoverColor: '#FF0000',
          activeColor: '#ffd700',
          backgroundColor: '#1e90ff',
        },
        predefine: [
          '#1e90ff',
          '#90ee90',
          '#ffd700',
        ],
        parms: []
      }
    },
    methods: {
      edit(conKey, componentFlag) {
        this.visible = true;
        this.conKey = conKey;
        this.componentFlag = componentFlag;
      },
      handleOk() {
        this.visible = false;
        this.$emit('setComponentData',
          JSON.stringify(this.form), this.conKey, this.componentFlag);
      },
      handleCancel() {
        this.visible = false;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/editMoudle/eleMenuSimple.vue